import React from 'react';

import {Box, Divider, Typography} from 'views/components';

const HeaderSection = (props) => {
  const {

  } = props;

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          gap: 1,
          m: {xs: 1, md: 2},
        }}
      >
        <Box
          component="img"
          src="/logo/quilt-icon.png"
          alt="CareQuilt Icon"
          sx={{
            width: {xs: 24, sm: 32, md: 40},
            height: {xs: 24, sm: 32, md: 40},
          }}
        />
        <Typography
          sx={{
            fontWeight: 700,
            color: 'primary.main',
            fontSize: {xs: 24, sm: 32, md: 40},
          }}
        >
          CareQuilt
        </Typography>
      </Box>

      <Divider
        sx={{
          borderColor: 'grey.500',
          borderBottomWidth: 2,
          width: '100%',
        }}
      />
    </>
  );
};

HeaderSection.propTypes = {

};

export default React.memo(HeaderSection);
